<template>
  <div>
    <el-button
      v-if="hasAuth('sys:coupons:add')"
      style="margin-bottom: 20px"
      type="primary"
      @click="addUpdateCouponsButton(null)"
    >
      添加优惠券
    </el-button>
    <el-button
      v-if="hasAuth('sys:coupons:add')"
      style="margin-bottom: 20px"
      type="primary"
      @click="CouponsSetting(null)"
    >
      券可叠加数配置
    </el-button>

    <el-table
      ref="multipleTable"
      :data="tableData"
      border
      stripe
      style="width: 100%"
      tooltip-effect="dark"
      @selection-change="handleSelectionChange"
    >
      <el-table-column
        align="center"
        label="券名称"
        prop="name"
        width="200"
      ></el-table-column>
      <el-table-column
        align="center"
        label="券类型"
        prop="waysObtain"
        width="140"
      >
        <template slot-scope="scope">
          <div v-if="scope.row.waysObtain == 1" type="success">
            单笔消费满多少送
          </div>
          <div v-else-if="scope.row.waysObtain == 2" type="success">
            新用户注册
          </div>
          <div v-else-if="scope.row.waysObtain == 3" type="success">
            活动赠送券
          </div>
          <div v-else-if="scope.row.waysObtain == 4" type="success">折扣券</div>
          <div v-else-if="scope.row.waysObtain == 5" type="success">品类券</div>
          <div v-else-if="scope.row.waysObtain == 6" type="success">单品券</div>
          <div v-else-if="scope.row.waysObtain == 7" type="success">
            邀新并下单
          </div>
          <div v-else-if="scope.row.waysObtain == 9" type="success">
            邀新并注册
          </div>
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        label="优惠规则类型"
        prop="rulesType"
        width="120"
      >
        <template slot-scope="scope">
          <el-tag v-if="scope.row.type === 2" size="small" type="success">
            满减
          </el-tag>
          <el-tag v-else-if="scope.row.type === 1" size="small" type="success">
            无门槛
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        label="获得方式"
        prop="releaseMode"
        width="120"
      >
        <template slot-scope="scope">
          <el-tag
            v-if="scope.row.releaseMode === 1"
            size="small"
            type="success"
          >
            自动发放
          </el-tag>
          <el-tag
            v-if="scope.row.releaseMode === 2"
            size="small"
            type="primary"
          >
            用户领取
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        label="是否可叠加使用"
        prop="releaseMode"
        width="160"
      >
        <template slot-scope="scope">
          <el-tag
            v-if="scope.row.isSuperposition === 1"
            size="small"
            type="success"
          >
            是
          </el-tag>
          <el-tag
            v-if="scope.row.isSuperposition === 0"
            size="small"
            type="primary"
          >
            否
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column align="center" label="券剩余数量" prop="num" width="120">
        <template slot-scope="{ row }">
          {{ row.waysObtain == 2 ? row.num : "/" }}
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        label="开始使用时间"
        prop="startTime"
        width="160"
      ></el-table-column>
      <el-table-column
        align="center"
        label="有效时间(天)"
        prop="validTime"
        width="120"
      ></el-table-column>
      <el-table-column
        align="center"
        label="产品名称"
        prop="commodityName"
        width="120"
      ></el-table-column>
      <el-table-column align="center" label="折扣" prop="discount" width="240">
        <template slot-scope="{ row }">
          <div v-if="row.waysObtain == 4">
            折扣：{{ row.discount }} ；折扣可用件数：{{ row.discountNum }}
          </div>
        </template>
      </el-table-column>
      <el-table-column align="center" label="品类" prop="discount" width="120">
        <template slot-scope="{ row }">
          <div v-if="row.waysObtain == 5">
            {{ row.classifyFirstName }}/{{ row.classifyName }}
          </div>
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        label="满减条件金额(元)"
        prop="satisfyAmount"
        width="160"
      >
      </el-table-column>
      <el-table-column
        align="center"
        label="优惠金额"
        prop="discountAmount"
        width="120"
      >
        <template slot-scope="{ row }">
          <span v-if="row.waysObtainMoney"
            >满{{ row.waysObtainMoney || "" }}元减{{
              row.discountAmount
            }}元</span
          >
          <span v-else>{{ row.discountAmount }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="状态" prop="rulesType" width="100">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.state === 0" size="small" type="info">
            已下架
          </el-tag>
          <el-tag v-else-if="scope.row.state === 1" size="small" type="success">
            已上架
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        label="创建时间"
        prop="createTime"
        width="200"
      ></el-table-column>
      <el-table-column
        align="center"
        fixed="right"
        label="操作"
        prop="icon"
        width="360"
      >
        <template slot-scope="scope">
          <el-button
            v-if="scope.row.state == 0 && hasAuth('sys:coupons:qiyong')"
            plain
            type="primary"
            @click="dateCouponsButton(scope.row.id)"
          >
            上架
          </el-button>
          <el-button
            v-if="scope.row.state == 1 && hasAuth('sys:coupons:jingyong')"
            plain
            type="danger"
            @click="dateCouponsButton(scope.row.id)"
          >
            下架
          </el-button>
          <template>
            <el-popconfirm
              v-if="hasAuth('sys:coupons:del') && scope.row.state != 1"
              title="确定删除该优惠券吗？"
              @confirm="delHandle(scope.row.id)"
            >
              <el-button slot="reference" plain type="danger">删除</el-button>
            </el-popconfirm>
          </template>
          <el-button
            v-if="scope.row.state == 1"
            plain
            type="primary"
            @click="sendfafang(scope.row)"
            >发放记录
          </el-button>
          <el-button
            v-if="
              scope.row.state == 1 &&
              scope.row.waysObtain == 3 &&
              scope.row.releaseMode == 1 &&
              hasAuth('sys:coupons:zengsong')
            "
            plain
            type="primary"
            @click="sendall(scope.row)"
            >赠送
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-pagination
      :current-page="current"
      :page-size="size"
      :page-sizes="[10, 20, 50, 100]"
      :total="total"
      layout="total, sizes, prev, pager, next, jumper"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
    ></el-pagination>
    <el-dialog
      :before-close="handleClose"
      :visible.sync="showpons"
      title="确定给所有人发送此优惠券吗？一但发送无法撤回!"
      width="70%"
    >
      <el-form>
        <el-form-item label="赠送人数">
          <el-select v-model="type" clearable placeholder="赠送人数">
            <el-option label="赠送个人" value="2"></el-option>
            <el-option label="赠送所有人" value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="赠送数量">
          <el-input
            v-model="copnum"
            clearable
            placeholder="请输入数量"
            style="width: 216px"
            type="number"
          ></el-input>
        </el-form-item>
      </el-form>
      <el-divider></el-divider>
      <div v-if="type == 2">
        <el-form :inline="true">
          <el-form-item label="用户昵称" label-width="80px">
            <el-input v-model="name" clearable placeholder="用户昵称">
            </el-input>
          </el-form-item>
          <el-form-item label="手机号" label-width="80px">
            <el-input v-model="phone" clearable placeholder="手机号">
            </el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="success" @click="getStoreGoods(1)">搜索</el-button>
          </el-form-item>
        </el-form>
        <el-table
          ref="multipleTable"
          :data="tableDatas"
          border
          stripe
          style="width: 100%"
          tooltip-effect="dark"
          @selection-change="handleSelectionChange"
        >
          <el-table-column align="center" label="用户头像">
            <template slot-scope="scope">
              <img
                :src="scope.row.avatarUrl"
                alt=""
                height="50px"
                width="50px"
              />
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            label="用户昵称"
            prop="nickName"
          ></el-table-column>
          <el-table-column
            align="center"
            label="用户手机号"
            prop="phone"
          ></el-table-column>
          <el-table-column
            align="center"
            label="注册时间"
            prop="createTime"
          ></el-table-column>
          <el-table-column
            align="center"
            fixed="right"
            label="操作"
            prop="icon"
          >
            <template slot-scope="scope">
              <el-button
                v-if="scope.row.userId == selectId"
                plain
                type="danger"
                @click="selsctButton(scope.row.userId)"
              >
                已选择
              </el-button>
              <el-button
                v-else
                plain
                type="primary"
                @click="selsctButton(scope.row.userId)"
              >
                选择
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          :current-page="currents"
          :page-size="sizes"
          :page-sizes="[10, 20, 50, 100]"
          :total="totals"
          layout="total, sizes, prev, pager, next, jumper"
          @size-change="handleSizeChanges"
          @current-change="handleCurrentChanges"
        >
        </el-pagination>
      </div>
      <div style="height: 40px"></div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showpons = false">取消</el-button>
        <el-button type="primary" @click="getfome()">确定</el-button>
      </span>
    </el-dialog>
    <AddUpdateCoupons
      v-if="addUpdateCouponsvisible"
      ref="addUpdateCoupons"
      @refreshDataList="getCoupons"
    >
    </AddUpdateCoupons>
    <SelectUsers
      v-if="getCouponsUserssvisible"
      ref="getCouponsUsers"
      @refreshDataList="getUsersList(scope.row.couponsId)"
    ></SelectUsers>
    <fafang ref="visfa" />
  </div>
</template>

<script>
import AddUpdateCoupons from "./AddUpdateCoupons";
import SelectUsers from "./SelectUsers";
import fafang from "./fafang.vue";

export default {
  name: "Coupons",
  components: {
    AddUpdateCoupons,
    SelectUsers,
    fafang,
  },
  data() {
    return {
      searchForm: {},
      delBtlStatu: true,
      tableData: [],
      tableDatas: [],
      multipleSelection: [],
      total: 0,
      size: 10,
      configNum: 0,
      current: 1,
      totals: 0,
      sizes: 10,
      currents: 1,
      addUpdateCouponsvisible: false,
      getCouponsUserssvisible: false,
      showpons: false,
      copnum: 1,
      type: "2",
      id: "",
      template: "",
      phone: "",
      name: "",
      selectId: "",
    };
  },
  created() {
    this.getCoupons();
    this.getuser();
    this.delConfig();
  },
  methods: {
    sendfafang(row) {
      this.$refs.visfa.init(row);
    },
    getStoreGoods(e) {
      this.currents = 1;
      this.getuser();
    },
    selsctButton(e) {
      if (e == this.selectId) {
        this.selectId = "";
      } else {
        this.selectId = e;
      }
    },
    toggleSelection(rows) {
      if (rows) {
        rows.forEach((row) => {
          this.$refs.multipleTable.toggleRowSelection(row);
        });
      } else {
        this.$refs.multipleTable.clearSelection();
      }
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
      this.delBtlStatu = val.length == 0;
    },

    handleSizeChange(val) {
      this.size = val;
      this.getCoupons();
    },
    handleCurrentChange(val) {
      this.current = val;
      this.getCoupons();
    },
    handleSizeChanges(val) {
      this.sizes = val;
      this.getuser();
    },
    handleCurrentChanges(val) {
      this.currents = val;
      this.getuser();
    },
    getuser() {
      this.$axios
        .post("/admin/userBase/getUserList", {
          pageNo: this.currents,
          pageSize: this.sizes,
          phone: this.phone,
          name: this.name,
        })
        .then((res) => {
          this.tableDatas = res.data.records;
          this.sizes = res.data.size;
          this.currents = res.data.current;
          this.totals = res.data.total;
        });
    },
    //获取资讯列表
    getCoupons() {
      var startTimes = "";
      var endTimes = "";
      if (this.searchForm.createTime != undefined) {
        startTimes = this.searchForm.createTime[0];
        endTimes = this.searchForm.createTime[1];
      }
      this.searchForm.startTimes = startTimes;
      this.searchForm.endTimes = endTimes;
      this.searchForm.pageNo = this.current;
      this.searchForm.pageSize = this.size;
      this.$axios
        .post("/admin/sysCouponSheet/getList", this.searchForm)
        .then((res) => {
          this.tableData = res.data.records;
          this.total = res.data.total;
        });
    },
    //选择用户
    getUsersList(couponsId) {
      this.getCouponsUserssvisible = true;
      this.$nextTick(() => {
        this.$refs.getCouponsUsers.init(couponsId);
      });
    },
    deCouponsButton(id) {},
    getfome() {
      if (this.type == 1) {
        this.$axios
          .post("/admin/sysCouponSheet/issueCoupon", {
            couponsId: this.id,
            number: this.copnum,
            type: this.type,
          })
          .then((res) => {
            this.getCoupons();
            this.showpons = false;
            this.$message({
              showClose: true,
              message: "恭喜你，操作成功",
              type: "success",
              onClose: () => {},
            });
          });
      } else {
        this.$axios
          .post("/admin/sysCouponSheet/issueCoupon", {
            couponsId: this.id,
            number: this.copnum,
            type: this.type,
            userId: this.selectId,
          })
          .then((res) => {
            this.getCoupons();
            this.showpons = false;
            this.selectId = "";
            this.$message({
              showClose: true,
              message: "恭喜你，操作成功",
              type: "success",
              onClose: () => {},
            });
          });
      }
    },
    sendall(e) {
      this.id = e.id;
      this.showpons = true;
    },
    handleClose() {
      this.showpons = false;
    },
    dateCouponsButton(id) {
      this.$axios
        .post("/admin/sysCouponSheet/updateState", {
          id: id,
        })
        .then((res) => {
          this.getCoupons();
          this.$message({
            showClose: true,
            message: "恭喜你，操作成功",
            type: "success",
            onClose: () => {},
          });
        });
    },
    //删除资讯
    delHandle(id) {
      this.$axios
        .post("/admin/sysCouponSheet/del", {
          id: id,
        })
        .then((res) => {
          this.getCoupons();
          this.$message({
            showClose: true,
            message: "恭喜你，操作成功",
            type: "success",
            onClose: () => {},
          });
        });
    },
    delConfig() {
      this.$axios.post("/admin/sysCouponSheet/getCouponConfig").then((res) => {
        this.configNum = res.data;
      });
    },
    CouponsSetting() {
      var _this = this;
      _this
        .$prompt(
          "请输入可叠加优惠券数量",
          `温馨提示：当前配置可叠加优惠券数量为：${_this.configNum}`,
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
          }
        )
        .then(({ value }) => {
          _this.$axios
            .post("/admin/sysCouponSheet/couponConfig", {
              num: value,
            })
            .then((res) => {
              _this.$message({
                showClose: true,
                message: "提交成功",
                type: "success",
                onClose: () => {},
              });
              _this.delConfig();
            });
        })
        .catch(() => {});
    },

    //下架、上架商城商品
    updCouponsIsOnframe(model) {
      this.$confirm(
        "操作需谨慎：此操作将是该优惠券" +
          (model.isOnframe === 0 ? "下架" : "上架") +
          "，是否继续?",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      ).then(() => {
        this.$axios
          .post("/admin/coupons/updCouponsIsOnframe", {
            couponsId: model.couponsId,
          })
          .then((res) => {
            this.$message({
              showClose: true,
              message: res.msg,
              type: "success",
              onClose: () => {
                this.getCoupons();
              },
            });
          });
      });
    },

    addUpdateCouponsButton(id) {
      this.addUpdateCouponsvisible = true;
      this.$nextTick(() => {
        this.$refs.addUpdateCoupons.init(id);
      });
    },
  },
};
</script>

<style scoped>
.el-button {
  padding: 0 10px;
  height: 35px;
  line-height: 35px;
  font-size: 15px;
  margin-right: 10px;
}
</style>
